import React, { Component } from 'react';
import preloader from '../../image/preloader.gif';

class Preloader extends Component {
  render() {
    return <div className="loader"><img src={preloader} alt="loading..." {...this.props} /></div>
  }
}

export default Preloader;



/** WEBPACK FOOTER **
 ** ./src/components/Preloader/index.js
 **/